import { MenuOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { HelpTopicsMobileToolbarStyled } from "./help-topics.page.styled";

interface IHelpTopicsMobileToolbarProps {
  onOpenSidebar: () => void;
}

export const HelpTopicsMobileToolbar: FC<IHelpTopicsMobileToolbarProps> = ({
  onOpenSidebar,
}) => {
  const { t } = useTranslation();

  return (
    <HelpTopicsMobileToolbarStyled>
      <IconButton
        size="small"
        onClick={onOpenSidebar}
        aria-label={t("helpTopics.openTopicsMenu", {
          defaultValue: "Open topics menu",
        })}
      >
        <MenuOutlined />
      </IconButton>
      <span className="HelpTopicsMobileToolbar-title">
        {t("helpTopics.title", { defaultValue: "Help topics" })}
      </span>
    </HelpTopicsMobileToolbarStyled>
  );
};
